import axios from 'axios';
import { isUnauthorizedResponse, logoutSession } from './sessionService';

axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },
    error => Promise.reject(error)
);

axios.interceptors.response.use(
    response => response,
    error => {
        if (isUnauthorizedResponse(error)) {
            logoutSession();
            return new Promise(() => {});
        }
        return Promise.reject(error);
    }
);

export default axios;